import type { BuildingFireSafetySections } from "../../../types/buildings-sections/fire-safety";

export const fireSafety: BuildingFireSafetySections = {
  title: "Fire Safety",
  description: "Building fire safety systems and protocol management",
  noDataAvailable: "Fire safety data not available",
  creatingRecord: "Creating fire safety record...",
  fireSafetyClass: "Fire Safety Class",
  selectFireSafetyClass: "Select fire safety class...",
  tp1: "TP1",
  tp2: "TP2",
  tp3: "TP3",
  occupancyLimits: "Occupancy Limits per Floor",
  fireSafetyPlan: "Fire Safety Plan (Link)",
  selfInspectionRequired: "Self-Inspection Required",
  lastInspection: "Last Inspection",
  systemStatus: "System Status",
  systemPresence: "Present Systems",
  systemDrawings: "System Drawings",
  scheduleInspection: "Schedule Inspection",
  operational: "Operational",
  partialFailure: "Partial Failure",
  nonOperational: "Non-Operational",
  addFloor: "Add Floor",
  addSystem: "Add System",
  addDrawing: "Add Drawing",
};
